Namespace 'Common.Dashboard.Filters'

CustomerVisualMode.Filters.GroupsFilterMixin =
  _getSelectedValues: ->
    values = @view.intelligentGroups()
    mapper = new CustomerVisualMode.Mappers.GroupsMapper
    mapper.mapToCompositeFilter({intelligent_groups: values})

  renderModal: (filter, groups) ->
    @view?.remove()
    @modalView?.remove()
    @view = new Customer.Filters.GroupsView(
      shouldTriggerEvents: true,
      hideToggle: true,
      disableDoneButtonWhenEmpty: true,
      terms: @_mapGroups(groups),
      customerFilter: @_buildCustomerFilter(filter)
    )
    @view.render()
    @modalView = new Common.Modals.ModalView({
      title: I18n.t('customer_visual_mode.filters.groups')
      contentView: @view
      size: {width: 1000, height: 550}
      modalOptions: {offset: {y: 30}}
    })
    @modalView.render()
    @view.openKeywordGroupsClick({stopPropagation: -> null})
    @listenTo(@view, 'groups:cancel', -> @modalView.closeModal())
    @listenTo(@view, 'groups:done', =>
      @modalView.closeModal()
      @applyFilter()
    )

  _buildCustomerFilter: (filter) ->
    mapper = new CustomerVisualMode.Mappers.GroupsMapper
    {
      intelligent_groups: mapper.mapToSearchQuery(filter.toJSON().intelligent_groups || {}),
      groups: []
    }

  _mapGroups: (groups) ->
    _.map(groups.models, (group) ->
      {
        description: group.get('description'),
        code: group.get('code'),
        type: group.get('type')
      }
    )
